<script>
    export let showMore;
    export let details;

    const onClick = () => {
        showMore = !showMore;
    }
</script>
<div class="show-more-button">
    <div
            role="button"
            tabindex="0"
            on:click={onClick}
            on:keydown={(e) => e.key === 'Enter' && onClick(e)}
            class="cursor-pointer text-sm pl-2 flex gap-2 items-center justify-between pr-2"
        >
            <div>
                {details}
            </div>
            <div class="bold">
                {#if showMore}
                    ↑
                {:else}
                    ↓
                {/if}
            </div>
    </div>
</div>

<style>
    .show-more-button {
        border-radius: 6px;
        padding: 5px;
        width: fit-content;
        min-width: 200px;
        border:1px solid #ddd;
    }
</style>
